<template>
    <DButton
        id="locale-toggle"
        icon="web"
        :title="otherLocale"
        @click="toggleLocale"
    />
</template>

<script>
import { router, usePage } from '@inertiajs/vue3'
import DButton from '~@/Components/Common/DButton'

export default {
    name: 'DLocaleToggle',
    components: {
        DButton
    },
    props: {
        userId: {
            type: Number,
            required: true
        }
    },
    computed: {
        currentLocale () {
            return usePage().props.locale ?? 'en'
        },
        otherLocale () {
            return this.currentLocale === 'en' ? 'de' : 'en'
        }
    },
    methods: {
        toggleLocale () {
            router.patch(this.$route('users.update_locale', { user: this.userId }), {
                locale: this.otherLocale
            })
        }
    }
}
</script>
